import { useSearch } from '@/react/portainer/gitops/queries/useSearch';

import { AutocompleteSelect } from '@@/form-components/AutocompleteSelect';
import { FormError } from '@@/form-components/FormError';

import { getAuthentication } from '../utils';
import { GitFormModel } from '../types';

export type PathSelectorGitModel = Pick<
  GitFormModel,
  | 'RepositoryAuthentication'
  | 'RepositoryPassword'
  | 'RepositoryUsername'
  | 'RepositoryGitCredentialID'
  | 'RepositoryAuthorizationType'
  | 'RepositoryURL'
  | 'RepositoryReferenceName'
  | 'TLSSkipVerify'
  | 'RepositoryURLValid'
>;

export function PathSelector({
  value,
  onChange,
  placeholder,
  model,
  dirOnly,
  readOnly,
  allowEmpty,
  inputId,
  createdFromCustomTemplateId,
  stackID,
  fromEdgeStack,
  hasError,
}: {
  value: string;
  onChange(value: string): void;
  placeholder: string;
  model: PathSelectorGitModel;
  dirOnly?: boolean;
  readOnly?: boolean;
  allowEmpty?: boolean;
  inputId: string;
  createdFromCustomTemplateId?: number;
  stackID?: number;
  fromEdgeStack?: boolean;
  hasError?: boolean;
}) {
  const creds = getAuthentication(model);
  const payload = {
    repository: model.RepositoryURL,
    keyword: value,
    reference: model.RepositoryReferenceName,
    tlsSkipVerify: model.TLSSkipVerify,
    dirOnly,
    createdFromCustomTemplateID: createdFromCustomTemplateId,
    stackID,
    fromEdgeStack,
    ...creds,
  };
  const enabled = Boolean(
    model.RepositoryURL && model.RepositoryURLValid && value
  );
  const { data: searchResults } = useSearch(payload, enabled);
  const isValueValid =
    (allowEmpty && value === '') || searchResults?.includes(value);

  return (
    <>
      <AutocompleteSelect
        searchResults={searchResults?.map((result) => ({
          value: result,
          label: result,
        }))}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        inputId={inputId}
        data-cy="git-ops-path-selector"
      />
      {!hasError && !isValueValid && <FormError>Path not found</FormError>}
    </>
  );
}
